
























import VueStrong from '@/vueStrong';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class Tabs extends VueStrong {
  public selectedIndex = 0;

  @Prop(Array) tabs!: string[];
  @Prop(Function) onTabSelected!: (i: number) => void;
  @Prop({
    type: Boolean,
    default: true,
  }) isFixed!: boolean;
  @Prop({
    type: Boolean,
    default: true,
  }) hasContent!: boolean;

  mounted():void {
    this.selectTab(0)
  }

  selectTab (i: number):void {
    if (this.onTabSelected) {
      this.onTabSelected(i);
    }

    this.selectedIndex = i;
  }
}
